import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Title from "/app/components/LandingPage/Title";
import useStyles from "/app/components/LandingPage/landingStyle-jss";
import ServiceInfo from "./ServiceInfo";
import "/app/components/LandingPage/Landing.css";
import CardServices from "./CardServices";

const ServicesIndex = (props) => {
  const { slideMode } = props;
  const { classes, cx } = useStyles();

  const [showMore, setShowMore] = useState(false);
  const visibleServices = showMore ? ServiceInfo : ServiceInfo.slice(0, 3);
  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="my-5">
      {/* <div className={cx(classes.container)}>
        <Grid
          container
          spacing={4}
          className={` gridContainer ${classes.root}`}
        >
          <Grid md={3}>
            <div>cnjnsca</div>
            <div>cnjnsca</div>
            <div>cnjnsca</div>
          </Grid>
        </Grid>

      </div> */}
      <div className={slideMode ? classes.fullWidth : classes.container}>
        <Title
          title="Services"
          desc="Integrated all your services at one platform"
          align="center"
          monocolor={slideMode && true}
        />
        {/* <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="Heading text-center">
                <h2>Service </h2>
              </div>
            </div>
          </div>
        </div> */}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                {/* {ServiceInfo.map((val, ind) => {
                  return (
                    <CardServices
                      key={ind}
                      serviceImg={val.imgsrc}
                      serviceTitle={val.serviceTitle}
                      serviceContent={val.serviceContent}
                      url={val.url}
                    />
                  );
                })} */}
                {/* <div> */}
                {visibleServices.map((val, ind) => (
                  <CardServices
                    key={ind}
                    serviceImg={val.imgsrc}
                    serviceTitle={val.serviceTitle}
                    serviceContent={val.serviceContent}
                    url={val.url}
                  />
                ))}
              </div>
              {ServiceInfo.length > 3 && (
                <Button
                  variant="contained"
                  className="mt-3"
                  onClick={handleShowMore}
                >
                  {showMore ? "Show Less" : "Show More"}
                </Button>
              )}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesIndex;
